<mat-dialog-content>
  <div class="warn-before-execution" *ngIf="!this.subscription.lockState">
    <h6>Are you sure you want to lock the resource '{{subscription.fullName}}'?</h6>
    <button mat-raised-button class="green-button"
    (click)="lockResource(lockStates.Locked)">
      Yes, lock
    </button>
    <button mat-raised-button class="red-button dialog-button-cancel" [mat-dialog-close]="true">
      No
    </button>
  </div>
  <div class="warn-before-execution" *ngIf="this.subscription.lockState">
    <h6>Are you sure you want to unlock the resource '{{subscription.fullName}}'?</h6>
    <button mat-raised-button class="green-button"
    (click)="lockResource(lockStates.Unlocked)">
      Yes, unlock
    </button>
    <button mat-raised-button class="red-button dialog-button-cancel" [mat-dialog-close]="true">
      No
    </button>
  </div>
  <div *ngIf="error" class="error-message">
    <mat-icon color="warn">error</mat-icon>
    {{ error }}
  </div>
</mat-dialog-content>
